import { SearchIcon } from 'components/src/svg';
import TextInputOld from 'components/src/textInput';
import * as React from 'react';

type Props = {
  searchValue: string | null;
  setSearchValue: React.Dispatch<React.SetStateAction<string | null>>;
};

const SearchBox = ({ searchValue, setSearchValue }: Props) => {
  return (
    <TextInputOld
      key={'leit'}
      id={'leit'}
      placeholder={'hverju ertu að leita að? '}
      type={'text'}
      value={searchValue || undefined}
      onChange={(value) => {
        if (value === '') {
          setSearchValue(null);
        } else setSearchValue(value);
      }}
      icon={<SearchIcon />}
      className="w-full"
    />
  );
};
export default SearchBox;
